import * as actionTypes from "./actionTypes";
import * as types from "./types";

const initTaskListState: types.TaskListState = {
    pending: false,
    tasks: {} as types.IDataTaskList,
    error: null,
};

export const TaskListReducer = (state = initTaskListState, action: types.TaskListActions) => {
    switch (action.type) {
        case actionTypes.FETCH_TASK_LIST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_TASK_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                tasks: action.payload.tasks,
                error: null,
            };
        case actionTypes.FETCH_TASK_LIST_FAILURE:
            return {
                ...state,
                pending: false,
                tasks: {} as types.IDataTaskList,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

const initLoaderListState: types.ILoaderListState = {
    pending: false,
    getLoaders: {} as types.IDataLoaderList,
    error: null,
};

export const LoaderListReducer = (state = initLoaderListState, action: types.LoaderListActions) => {
    switch (action.type) {
        case actionTypes.FETCH_LOADER_LIST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_LOADER_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                getLoaders: action.payload.getLoaders,
                error: null,
            };
        case actionTypes.FETCH_LOADER_LIST_FAILURE:
            return {
                ...state,
                pending: false,
                getLoaders: {} as types.IDataLoaderList,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

const initEventTaskListState: types.EventTaskListState = {
    pending: false,
    eventTasks: {} as types.IDataEventTaskList,
    error: null,
};

export const EventTaskListReducer = (state = initEventTaskListState, action: types.EventTaskListActions) => {
    switch (action.type) {
        case actionTypes.FETCH_EVENT_TASK_LIST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_EVENT_TASK_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                eventTasks: action.payload.eventTasks,
                error: null,
            };
        case actionTypes.FETCH_EVENT_TASK_LIST_FAILURE:
            return {
                ...state,
                pending: false,
                eventTasks: {} as types.IDataEventTaskList,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};


const initEventListState: types.EventListState = {
    pending: false,
    events: {} as types.IEventList,
    error: null,
};

export const EventListReducer = (state = initEventListState, action: types.EventListActions) => {
    switch (action.type) {
        case actionTypes.FETCH_EVENT_LIST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_EVENT_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                events: action.payload.events,
                error: null,
            };
        case actionTypes.FETCH_EVENT_LIST_FAILURE:
            return {
                ...state,
                pending: false,
                events: {} as types.IEventList,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

const initInboundListState: types.InboundListState = {
    pending: false,
    inboundEvents: {} as types.IInboundList,
    error: null,
};

export const InboundListReducer = (state = initInboundListState, action: types.InboundListActions) => {
    switch (action.type) {
        case actionTypes.FETCH_INBOUND_LIST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_INBOUND_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                inboundEvents: action.payload.inboundEvents,
                error: null,
            };
        case actionTypes.FETCH_INBOUND_LIST_FAILURE:
            return {
                ...state,
                pending: false,
                inboundEvents: {} as types.IInboundList,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

const initOutboundListState: types.IOutboundListState = {
    pending: false,
    outboundEvents: {} as types.IOutboundList,
    error: null,
};

export const OutboundListReducer = (state = initOutboundListState, action: types.OutboundListActions) => {
    switch (action.type) {
        case actionTypes.FETCH_OUTBOUND_LIST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_OUTBOUND_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                outboundEvents: action.payload.outboundEvents,
                error: null,
            };
        case actionTypes.FETCH_OUTBOUND_LIST_FAILURE:
            return {
                ...state,
                pending: false,
                outboundEvents: {} as types.IOutboundList,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};


//Post Task 
const initTaskState: types.IPostTaskState = {
    pending: false,
    taskId: null,
    error: null,
};

export const PostTaskReducer = (state = initTaskState, action: types.PostTaskActions) => {
    switch (action.type) {
        case actionTypes.POST_TASK_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.POST_TASK_SUCCESS:
            return {
                ...state,
                pending: false,
                taskId: action.payload.taskId,
                error: null,
            };
        case actionTypes.POST_TASK_FAILURE:
            return {
                ...state,
                pending: false,
                taskId: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};


const initTaskConnectionState: types.ITaskConnectionState = {
    pending: false,
    taskConnection: {} as types.TaskConnectionList,
    error: null,
};

export const TaskConnectionReducer = (state = initTaskConnectionState, action: types.TaskConnectionActions) => {
    switch (action.type) {
        case actionTypes.FETCH_TASK_CONNECTION_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_TASK_CONNECTION_SUCCESS:
            return {
                ...state,
                pending: false,
                taskConnection: action.payload.taskConnection,
                error: null,
            };
        case actionTypes.FETCH_TASK_CONNECTION_RESET:
            return {
                ...state,
                pending: false,
                taskConnection: {} as types.TaskConnectionList,
                error: null,
            };
        case actionTypes.FETCH_TASK_CONNECTION_FAILURE:
            return {
                ...state,
                pending: false,
                taskConnection: {} as types.TaskConnectionList,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

//Post Task Connection
const initPostTaskConnectionState: types.IPostTaskConnectionState = {
    pending: false,
    taskConnectionId: null,
    error: null,
};

export const PostTaskConnectionReducer = (state = initPostTaskConnectionState, action: types.PostTaskConnectionActions) => {
    switch (action.type) {
        case actionTypes.POST_TASK_CONNECTION_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.POST_TASK_CONNECTION_SUCCESS:
            return {
                ...state,
                pending: false,
                taskConnectionId: action.payload.taskConnectionId,
                error: null,
            };
        case actionTypes.POST_TASK_CONNECTION_FAILURE:
            return {
                ...state,
                pending: false,
                taskConnectionId: null,
                error: action.payload.error,
            };
            case actionTypes.POST_TASK_CONNECTION_RESET:
                return {
                    ...state,
                    pending: false,
                    taskConnectionId: null,
                    error: null,
                };
        default:
            return {
                ...state,
            };
    }
};

export default { TaskListReducer, EventListReducer, InboundListReducer, EventTaskListReducer, OutboundListReducer, PostTaskReducer, TaskConnectionReducer, PostTaskConnectionReducer };


